import { Modal, Box, Typography, Divider, IconButton } from '@mui/material';
import styles from './styles';
import { FormPopupProps } from './types';

const FormsPopup = ({
    title,
    description,
    open,
    id = 'modal',
    handleClose,
    width = 300,
    textAlign,
    ...props
}: FormPopupProps) => {
    return (
        <Modal
            id={id}
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-title"
            aria-describedby="modal-description"
            BackdropProps={{
                sx: styles.modal_backdrop,
            }}
            sx={styles.formsModal}
        >
            <Box sx={styles.modal(width)}>
                <Typography id="modal-title" variant="h6" component="h2" sx={[styles.title, { textAlign }]}>
                    {title}
                    <IconButton id="modal_pop_up_close" onClick={handleClose} sx={styles.close}>
                        <img alt="modal-close" src="/images/close.svg" />
                    </IconButton>
                </Typography>
                {description ? (
                    <>
                        <Typography
                            id="modal-description"
                            data-testid="modal-description"
                            sx={[styles.description, { textAlign }]}
                            component="div"
                        >
                            {description}
                        </Typography>
                        <Divider sx={styles.divider} />
                    </>
                ) : null}
                <Typography component="div">{props.children}</Typography>
            </Box>
        </Modal>
    );
};

export default FormsPopup;
